import { gql, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

import { GET_PAYROLL_ACCOUNTING } from './get-payroll-accounting.hook';

export const CREATE_DATEV_FILE = gql`
  mutation createDatevPayrollAccountingFile($payload: CreatePayrollAccountingInput!) {
    createDatevPayrollAccountingFile(payload: $payload) {
      _id
    }
  }
`;

export const useCreateDatevPayrollAccountingFile = ({ onSuccess }: { onSuccess?: () => void }) => {
  const { t } = useTranslation('payrollAccounting');
  const [createDatevPayrollAccountingFile] = useMutation(CREATE_DATEV_FILE, {
    onCompleted: data => {
      if (data?.createDatevPayrollAccountingFile?._id) {
        showNotification({
          isIcon: false,
          type: NOTIFICATION_TYPE.success,
          message: t('notifications.fileCreated'),
        });
      }
      if (onSuccess) {
        onSuccess();
      }
    },
    refetchQueries: [GET_PAYROLL_ACCOUNTING],
  });
  return createDatevPayrollAccountingFile;
};
